import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import PageHeader from 'components/PageHeader';
import { useGetAppSettings } from './hooks';
import AppSettingsForm from './components/AppSettingsForm';

export const path = '/app/settings';

function AppSettingsPage() {
  const { data, loading, success, error, setData, fetchSettings } = useGetAppSettings();

  useEffect(() => {
    fetchSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ maxWidth: 1305, mx: 'auto', p: 3, display: 'flex', flexDirection: 'column', gridGap: 24 }}>
      <PageHeader title="Настройки приложения" />

      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
          <Typography component="h3" variant="h4" align="center">
            {error}
          </Typography>
        </Box>
      ) : (
        success &&
        (data?.length ? (
          <AppSettingsForm settings={data} onSave={setData} />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
            <Typography component="h3" variant="h4" align="center">
              Данные отсутствуют
            </Typography>
          </Box>
        ))
      )}
    </Box>
  );
}

export default AppSettingsPage;
